import { Component } from '@angular/core';
import { ND } from '@pt/pt-models';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';

@Component({
  selector: 'pt-footer-renderer',
  template: `
    <div class='pt-footer-renderer'>
      {{ "LABELS.ITEMS" | translate }}: {{ totalRow | replaceNullWithText: ND }}
    </div>
  `,
  styles: [`
    .pt-footer-renderer {
      background-color: white;
      width: 100%;
      height: 100%;
      display: flex;
      color: #686868;
      align-items: center;
      justify-content: flex-end;
      padding: 0 12px 0 12px;
    }
  `]
})
export class FooterRenderComponent implements ICellRendererAngularComp, IHeaderAngularComp {

  public params: any;
  public ND = ND;
  public totalRow = 0;

  agInit(params: any): void {
    this.params = params;
    this.totalRow = this.params.api.getDisplayedRowCount();
  }

  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }

}
